import React from "react";
import { Box, CircularProgress, FormControl, MenuItem, Select, Stack, Typography } from "@mui/material";
import type { ClientSummary } from "../api/clientManagement";
import { SectionCard } from "./SectionCard";

interface ClientScopeSelectorProps {
  isCentralAdmin: boolean;
  selectedClientId: string;
  selectedClient: ClientSummary | null;
  clients: ClientSummary[];
  onChange: (clientId: string) => void;
  userCount: number | null;
  userCountLoading: boolean;
}

export const ClientScopeSelector: React.FC<ClientScopeSelectorProps> = ({
  isCentralAdmin,
  selectedClientId,
  selectedClient,
  clients,
  onChange,
  userCount,
  userCountLoading,
}) => {
  if (!isCentralAdmin) return null;

  return (
    <SectionCard
      title="Client scope"
      description="Pick a client to manage branding, departments, roles, and users."
    >
      <Stack direction="row" spacing={4} alignItems="center" flexWrap="wrap">
        <FormControl size="small" sx={{ maxWidth: 360, minWidth: 200 }}>
          <Select
            value={selectedClientId}
            displayEmpty
            onChange={(event) => onChange(event.target.value)}
            renderValue={(value) => {
              if (!value) return "Select a client";
              return selectedClient?.name ?? value;
            }}
          >
            <MenuItem value="">
              <em>Select a client</em>
            </MenuItem>
            {clients.map((client) => (
              <MenuItem key={client.id} value={client.id}>
                {client.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {selectedClientId && (
          <>
            <Box>
              <Typography variant="caption" color="text.secondary" display="block">
                Total Users
              </Typography>
              <Typography variant="h6" fontWeight={600}>
                {userCountLoading ? (
                  <CircularProgress size={16} />
                ) : (
                  userCount ?? 0
                )}
              </Typography>
            </Box>
            <Box>
              <Typography variant="caption" color="text.secondary" display="block">
                Active Users
              </Typography>
              <Typography variant="h6" fontWeight={600}>
                {userCountLoading ? (
                  <CircularProgress size={16} />
                ) : (
                  userCount ?? 0
                )}
              </Typography>
            </Box>
          </>
        )}
      </Stack>
    </SectionCard>
  );
};
